<template>
  <PageTitle pageTitle="Editar Usuário" mainTitle="Editar Usuário" />

  <v-card class="mb-25 pingo-card">
    <!-- Navigate -->
    <!-- <ul class="ps-0 mt-0">
      <li>
        <a
          :class="{ 'router-link-active active': tab === 'personal' }"
          @click="tab = 'personal'"
        >
          Informações Pessoais
        </a>
      </li>
      <li>
        <a
          :class="{ 'router-link-active active': tab === 'address' }"
          @click="tab = 'address'"
        >
          Informações de Endereço</a
        >
      </li>
    </ul> -->

    <!-- Form: Personal -->
    <v-form v-if="tab == 'personal'" @submit.prevent="handleSubmit()">
      <v-row>
        <v-col lg="12" md="12">
          <div class="v-card-header border-bottom">
            <h5 class="mb-0">Informações Pessoais</h5>
          </div>

          <v-row>
            <v-col cols="12" lg="6" md="6">
              <div class="pingo-form-group without-icon">
                <label class="d-block mb-12 fw-semibold gray-color">
                  Nome
                  <span>*</span>
                </label>

                <TextInput
                  :label="'Digite o nome do usuário aqui'"
                  :type="'email'"
                  v-model="updateUserForm.name"
                  :error-messages="
                    v$.name.$errors ? v$.name.$errors[0]?.$message : undefined
                  "
                />
              </div>
            </v-col>

            <v-col cols="12" lg="6" md="6">
              <div class="pingo-form-group without-icon">
                <label class="d-block mb-12 fw-semibold gray-color">
                  Email
                  <span>*</span>
                </label>

                <TextInput
                  :label="'Digite o email do usuário aqui'"
                  :type="'email'"
                  v-model="updateUserForm.email"
                  :error-messages="
                    v$.email.$errors ? v$.email.$errors[0]?.$message : undefined
                  "
                />
              </div>
            </v-col>

            <!-- <v-col cols="12" lg="6" md="6">
              <div class="pingo-form-group without-icon">
                <label class="d-block mb-12 fw-semibold gray-color">
                  Documento <span>*</span>
                </label>

                <CpfInput
                  v-if="updateUserForm.type != 'BUSINESS'"
                  :label="'Digite o CPF do usuário aqui'"
                  v-model="updateUserForm.document"
                  :required="true"
                  @update:value="(value: string) => updateUserForm.document = value.replaceAll('.','').replace('-','')"
                  :error-messages="
                    v$.document.$errors
                      ? v$.document.$errors[0]?.$message
                      : undefined
                  "
                />

                <CnpjInput
                  v-if="updateUserForm.type == 'BUSINESS'"
                  :label="'Digite o CNPJ do usuário aqui'"
                  v-model="updateUserForm.document"
                  :required="true"
                  @update:value="(value: string) => updateUserForm.document = value.replaceAll('.','').replace('-','')"
                  :error-messages="
                    v$.document.$errors
                      ? v$.document.$errors[0]?.$message
                      : undefined
                  "
                />
              </div>
            </v-col> -->

            <!-- <v-col cols="12" lg="6" md="6">
              <div class="pingo-form-group without-icon mb-0">
                <label class="d-block mb-12 fw-semibold gray-color">
                  Celular <span>*</span>
                </label>

                <PhoneInput
                  :label="'Digite o celular do usuário aqui'"
                  :type="'tel'"
                  v-model="updateUserForm.phone"
                  :error-messages="
                    v$.phone.$errors ? v$.phone.$errors[0]?.$message : undefined
                  "
                />
              </div>
            </v-col> -->

            <!-- <v-col cols="12" lg="6" md="6">
              <div class="pingo-form-group without-icon mb-0">
                <label class="d-block mb-12 fw-semibold gray-color">
                  Tipo de usuário
                  <span>*</span>
                </label>

                <v-select
                  label="Selecione um tipo"
                  @update:model-value="(value: 'ADMIN' | 'PARTNER' | 'BUSINESS' | 'COLLABORATOR' | 'BENEFICIARY') => updateUserForm.type = value"
                  :items="[
                    {
                      title: 'Administrador',
                      value: 'ADMIN',
                    },
                    {
                      title: 'Parceiro',
                      value: 'PARTNER',
                    },
                    {
                      title: 'Empresa',
                      value: 'BUSINESS',
                    },
                    {
                      title: 'Colaborador',
                      value: 'COLLABORATOR',
                    },
                    {
                      title: 'Beneficiário',
                      value: 'BENEFICIARY',
                    },
                  ]"
                  v-model="updateUserForm.type"
                  :error-messages="
                    v$.type.$errors ? v$.type.$errors[0]?.$message : undefined
                  "
                />
              </div>
            </v-col> -->

            <v-col v-if="userData.type == 'ADMIN'" cols="12" lg="6" md="6">
              <div class="pingo-form-group without-icon">
                <label class="d-block mb-12 fw-semibold gray-color">
                  Dia de Cobrança
                  <span>*</span>
                </label>

                <TextInput
                  :label="'Digite o dia de cobrança aqui'"
                  :type="'number'"
                  v-model="updateUserForm.billingDay"
                  @update:value="(value: number) => updateUserForm.billingDay = value"
                  :error-messages="
                    v$.billingDay.$errors
                      ? v$.billingDay.$errors[0]?.$message
                      : undefined
                  "
                />
              </div>
            </v-col>

            <v-col cols="12" lg="6" md="6">
              <div class="pingo-form-group without-icon">
                <label class="d-block mb-12 fw-semibold gray-color">
                  Senha
                </label>

                <TextInput
                  :label="'Digite a senha do usuário aqui'"
                  :type="'password'"
                  v-model="updateUserForm.password"
                  :error-messages="
                    v$.password.$errors
                      ? v$.password.$errors[0]?.$message
                      : undefined
                  "
                />
              </div>
            </v-col>

            <v-col cols="12" lg="6" md="6">
              <div class="pingo-form-group without-icon mb-0">
                <label class="d-block mb-12 fw-semibold gray-color">
                  Confirme a sua senha
                </label>

                <TextInput
                  :label="'Digite a senha novamente'"
                  :type="'password'"
                  v-model="updateUserForm.confirmationPassword"
                  :error-messages="
                    v$.confirmationPassword.$errors
                      ? v$.confirmationPassword.$errors[0]?.$message
                      : undefined
                  "
                />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>

    <!-- Form: Address -->
    <v-form v-if="tab == 'address'" @submit.prevent="handleSubmit()">
      <v-row>
        <v-col lg="12" md="12">
          <v-card class="create-project-card pingo-card">
            <div class="v-card-header border-bottom">
              <h5 class="mb-0">Informações de Endereço</h5>
            </div>

            <v-row>
              <v-col cols="12" lg="6" md="6">
                <div class="pingo-form-group without-icon">
                  <label class="d-block mb-12 fw-semibold gray-color">
                    CEP
                    <span>*</span>
                  </label>

                  <PostalCodeInput
                    :label="'Digite o seu CEP aqui'"
                    v-model="newAddressForm.zipCode"
                    @update:value="(value: string) => updatePostalCode(value)"
                    :error-messages="
                      v$address.zipCode.$errors
                        ? v$address.zipCode.$errors[0]?.$message
                        : undefined
                    "
                  />
                </div>
              </v-col>

              <v-col cols="12" lg="6" md="6">
                <div class="pingo-form-group without-icon">
                  <label class="d-block mb-12 fw-semibold gray-color">
                    Rua
                    <span>*</span>
                  </label>
                  <TextInput
                    :label="'Nome da rua'"
                    v-model="newAddressForm.street"
                    :error-messages="
                      v$address.street.$errors
                        ? v$address.street.$errors[0]?.$message
                        : undefined
                    "
                  />
                </div>
              </v-col>

              <v-col cols="12" lg="6" md="6">
                <div class="pingo-form-group without-icon">
                  <label class="d-block mb-12 fw-semibold gray-color">
                    Bairro
                    <span>*</span>
                  </label>
                  <TextInput
                    :label="'Digite o bairro aqui'"
                    v-model="newAddressForm.neighborhood"
                    :error-messages="
                      v$address.neighborhood.$errors
                        ? v$address.neighborhood.$errors[0]?.$message
                        : undefined
                    "
                  />
                </div>
              </v-col>

              <v-col cols="12" lg="6" md="6">
                <div class="pingo-form-group without-icon">
                  <label class="d-block mb-12 fw-semibold gray-color">
                    Cidade
                    <span>*</span>
                  </label>
                  <TextInput
                    :label="'Digite a cidade aqui'"
                    v-model="newAddressForm.city"
                    :error-messages="
                      v$address.city.$errors
                        ? v$address.city.$errors[0]?.$message
                        : undefined
                    "
                  />
                </div>
              </v-col>

              <v-col cols="12" lg="6" md="6">
                <div class="pingo-form-group without-icon">
                  <label class="d-block mb-12 fw-semibold gray-color">
                    Estado
                    <span>*</span>
                  </label>
                  <TextInput
                    :label="'Digite o estado aqui'"
                    v-model="newAddressForm.state"
                    :error-messages="
                      v$address.state.$errors
                        ? v$address.state.$errors[0]?.$message
                        : undefined
                    "
                  />
                </div>
              </v-col>

              <v-col cols="12" lg="6" md="6">
                <div class="pingo-form-group without-icon">
                  <label class="d-block mb-12 fw-semibold gray-color">
                    Número
                    <span>*</span>
                  </label>
                  <TextInput
                    :label="'Digite o número aqui'"
                    v-model="newAddressForm.number"
                    :error-messages="
                      v$address.number.$errors
                        ? v$address.number.$errors[0]?.$message
                        : undefined
                    "
                  />
                </div>
              </v-col>

              <v-col cols="12" lg="6" md="6">
                <div class="pingo-form-group without-icon">
                  <label class="d-block mb-12 fw-semibold gray-color">
                    Complemento
                  </label>
                  <TextInput
                    :label="'Digite o complemento aqui (opcional)'"
                    v-model="newAddressForm.complement"
                  />
                </div>
              </v-col>

              <v-col cols="12" lg="6" md="6">
                <div class="pingo-form-group without-icon mb-0">
                  <label class="d-block mb-12 fw-semibold gray-color">
                    Endereço Principal?
                    <span>*</span>
                  </label>
                  <v-select
                    v-model="newAddressForm.isDefault"
                    :items="[
                      { title: 'Sim', value: true },
                      { title: 'Não', value: false },
                    ]"
                    :error-messages="
                      v$address.isDefault.$errors
                        ? v$address.isDefault.$errors[0]?.$message
                        : undefined
                    "
                  />
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-form>

    <div class="text-end">
      <button
        type="button"
        class="default-btn"
        :disabled="isLoadingUserRequest"
        @click="handleSubmitGeneral()"
      >
        <v-progress-circular
          v-if="isLoadingUserRequest"
          indeterminate
          size="18"
          width="2"
        ></v-progress-circular>

        <span v-if="isLoadingUserRequest"> Atualizando Usuário... </span>
        <span v-if="!isLoadingUserRequest"> Atualizar Usuário </span>
      </button>
    </div>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, onMounted, Ref, ref } from "vue";

import { useRoute, useRouter } from "vue-router";

import { useVuelidate } from "@vuelidate/core";

import { useAuthStore } from "@/stores/auth.store";
import { useLoadingDialog } from "@/stores/loading.store";

import { useUser } from "@/composables/useUser";
import { useAddress } from "@/composables/useAddress";
import { useViaCEP } from "@/composables/useViaCEP";

import PageTitle from "@/components/Common/PageTitle.vue";

import TextInput from "@/components/Forms/BasicElements/Input/TextInput.vue";
// import CpfInput from "@/components/Forms/AdvancedElements/Input/CpfInput.vue";
// import CnpjInput from "@/components/Forms/AdvancedElements/Input/CnpjInput.vue";
// import PhoneInput from "@/components/Forms/AdvancedElements/Input/PhoneInput.vue";

import PostalCodeInput from "@/components/Forms/AdvancedElements/Input/PostalCodeInput.vue";

export default defineComponent({
  name: "EditUserPage",
  components: {
    PageTitle,
    TextInput,
    // CpfInput,
    // CnpjInput,
    // PhoneInput,
    PostalCodeInput,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();

    const authStore = useAuthStore();
    const loadingStore = useLoadingDialog();

    const userData: Ref = ref(authStore.getUser);

    const {
      user,
      updateUserForm,
      updateUserFormRules,
      getUserById,
      updateUser,
    } = useUser();

    const { address: viaCEPAddress, getAddress } = useViaCEP();

    const {
      // address,
      newAddressForm,
      newAddressFormRules,
      // getAddressById,

      createAddress,
    } = useAddress();

    const tab = ref("personal");

    const isLoadingUserInfo = ref(false);
    const isLoadingUserRequest = ref(false);

    // const isLoadingAddressInfo = ref(false);
    const isLoadingAddressRequest = ref(false);

    const fetchUserData = async (user_id: number) => {
      try {
        isLoadingUserInfo.value = true;

        await getUserById(user_id);

        isLoadingUserInfo.value = false;

        updateUserForm.name = user.value?.name ?? "";
        updateUserForm.email = user.value?.email ?? "";
        updateUserForm.document = user.value?.document ?? "";
        updateUserForm.phone = user.value?.phone ?? "";

        const type = route.query.type;
        if (type)
          updateUserForm.type = type.toString() as
            | "ADMIN"
            | "PARTNER"
            | "BUSINESS"
            | "COLLABORATOR"
            | "BENEFICIARY";

        updateUserForm.billingDay = user.value?.billingDay;
      } catch (error) {
        console.error("Erro ao buscar detalhes de usuário:", error);
      }
    };

    // const fetchAddressData = async (id: number) => {
    //   try {
    //     isLoadingAddressInfo.value = true;

    //     getAddressById(id).then(() => {
    //       isLoadingAddressInfo.value = false;

    //       newAddressForm.isDefault = address.value?.isDefault == 1;
    //       newAddressForm.complement = address.value?.complement ?? "";
    //       newAddressForm.number = address.value?.number ?? "";
    //       newAddressForm.neighborhood = address.value?.neighborhood ?? "";
    //       newAddressForm.country = address.value?.country ?? "";
    //       newAddressForm.state = address.value?.state ?? "";
    //       newAddressForm.city = address.value?.city ?? "";
    //       newAddressForm.street = address.value?.street ?? "";
    //       newAddressForm.zipCode = address.value?.zipCode ?? "";
    //     });
    //   } catch (error) {
    //     console.error("Erro ao buscar detalhes de endereço:", error);
    //   }
    // };

    const updatePostalCode = (value: string) => {
      if (value.length == 9)
        getAddress(value).then(() => {
          if (viaCEPAddress.value) {
            newAddressForm.street = viaCEPAddress.value.logradouro;
            newAddressForm.complement = viaCEPAddress.value.complemento;
            newAddressForm.neighborhood = viaCEPAddress.value.bairro;
            newAddressForm.city = viaCEPAddress.value.localidade;
            newAddressForm.state = viaCEPAddress.value.uf;
          }
        });
    };

    const handleSubmit = async () => {
      const result = await v$.value.$validate();

      if (!result) return;

      loadingStore.setLoading("Atualizando usuário...");

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { confirmationPassword, ...updateUserFormPayload } = updateUserForm;

      if (updateUserFormPayload.billingDay)
        updateUserFormPayload.billingDay = +updateUserFormPayload.billingDay;

      updateUserFormPayload.userParentId = userData.value.userId;
      updateUserFormPayload.document = updateUserFormPayload.document.replace(
        /\D/g,
        ""
      );
      updateUserFormPayload.phone = updateUserFormPayload.phone.replace(
        /\D/g,
        ""
      );

      if (userData.value.type != "ADMIN") {
        delete updateUserFormPayload.billingDay;
        delete updateUserFormPayload.dueDays;
      }

      const userId = parseInt(route.params.id.toString());

      const response = await updateUser(userId, updateUserFormPayload);

      loadingStore.setLoadingOff();

      if (response) {
        setTimeout(() => {
          router.go(-1);
        }, 2000);
      }
    };

    const handleSubmitAddress = async () => {
      newAddressForm.country = "Brasil";

      const result = await v$address.value.$validate();

      if (!result) return;

      isLoadingAddressRequest.value = !isLoadingAddressRequest.value;

      newAddressForm.userId = parseInt(route.params.id.toString());

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { ...newAddressFormPayload } = newAddressForm;

      const response = await createAddress(newAddressFormPayload);

      isLoadingAddressRequest.value = !isLoadingAddressRequest.value;

      if (response)
        setTimeout(() => {
          router.go(-1);
        }, 2000);
    };

    const handleSubmitGeneral = async () => {
      if (tab.value === "personal") {
        await handleSubmit();
      } else if (tab.value === "address") {
        await handleSubmitAddress();
      }
    };

    onMounted(() => {
      const userId = parseInt(route.params.id.toString());
      fetchUserData(userId);

      // const addressId = parseInt(route.params.id.toString());
      // fetchAddressData(addressId);
    });

    const v$ = useVuelidate(updateUserFormRules, updateUserForm);
    const v$address = useVuelidate(newAddressFormRules, newAddressForm);

    return {
      v$,
      v$address,
      route,
      router,
      userData,
      tab,
      isLoadingUserInfo,
      isLoadingUserRequest,
      newAddressForm,
      updatePostalCode,
      updateUserForm,
      handleSubmit,
      handleSubmitAddress,
      handleSubmitGeneral,
    };
  },
});
</script>

<style lang="scss" scoped>
.pingo-form-group {
  margin-bottom: 0px;
}

.box {
  h5 {
    font-size: 16px;
  }
  .list {
    display: flex;
    flex-direction: column;
    list-style-type: none;

    li {
      margin-bottom: 13px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.address-card {
  border: 1px solid #ccc !important;
}

.v-input__details {
  display: none !important;
}
button {
  &.success {
    background-color: var(--heraBlueColor);
    color: var(--whiteColor);
  }
  font: {
    weight: 600 !important;
    size: 14px !important;
  }
}
ul {
  list-style-type: none;
  margin-bottom: 15px;

  li {
    display: inline-block;
    margin: {
      right: 15px;
      bottom: 15px;
    }
    a {
      color: var(--paragraphColor);
      background-color: #f4f4f4;
      display: inline-block;
      border-radius: 5px;
      padding: 10px 25px;
      font: {
        size: var(--fontSize);
        weight: 600;
      }
      &:hover,
      &.active {
        background-color: var(--heraBlueColor);
        color: var(--whiteColor);
      }
    }
    &:last-child {
      margin-right: 0;
    }
  }
}

@media only screen and (max-width: 767px) {
  ul {
    li {
      a {
        font-size: 14px;
      }
    }
  }

  .box {
    h5 {
      font-size: 15px;
    }
  }
}
</style>
